import Vue from 'vue'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
} from '@fortawesome/vue-fontawesome'

import {
  faAddressCard,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowAltCircleRight,
  faBars,
  faBell,
  faBookOpen,
  faCalculator,
  faCog,
  faDrawPolygon,
  faCaretDown,
  faCaretUp,
  faCaretLeft,
  faCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFileInvoiceDollar,
  faFileUpload,
  faFolderOpen,
  faHandshake,
  faHandshakeSlash,
  faHeartBroken,
  faHome,
  faInfoCircle,
  faMinus,
  faComments,
  faCopy,
  faPaperPlane,
  faPencilAlt,
  faPercent,
  faPizzaSlice,
  faPlus,
  faQuestionCircle,
  faRocket,
  faSave,
  faSearch,
  faSearchPlus,
  faSignOutAlt,
  faSortDown,
  faSortUp,
  faStar,
  faStream,
  faThumbsUp,
  faTimes,
  faTrashAlt,
  faUniversity,
  faUser,
  faUserAltSlash,
  faUserEdit,
  faUserFriends,
  faUserPlus,
  faUserTie,
  faExternalLinkAlt,
  faEnvelope,
  faChevronDown,
  faArchive,
  faSync,
  faPhone,
  faCheckCircle,
  faMinusCircle,
  faEquals,
  faNotEqual,
  faGreaterThanEqual,
  faLessThanEqual,
  faUmbrella,
  faLock,
  faLockOpen,
  faUndo,
  faBrain,
  faDownload,
} from '@fortawesome/free-solid-svg-icons'
import { faWindows } from '@fortawesome/free-brands-svg-icons'
import {
  faAlarmSnooze,
  faConstruction,
  faBan,
  faRepeat,
  faSparkles,
  faPlusCircle,
} from '@fortawesome/pro-regular-svg-icons'

import { faHouseLock } from '@fortawesome/pro-solid-svg-icons'

config.autoAddCss = false

library.add(
  faAddressCard,
  faAlarmSnooze,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowAltCircleRight,
  faBars,
  faBell,
  faBookOpen,
  faCalculator,
  faCog,
  faDrawPolygon,
  faCaretUp,
  faCaretDown,
  faCaretLeft,
  faCheck,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFileInvoiceDollar,
  faFileUpload,
  faFolderOpen,
  faHandshake,
  faHandshakeSlash,
  faHeartBroken,
  faHome,
  faInfoCircle,
  faMinus,
  faComments,
  faCopy,
  faPaperPlane,
  faPencilAlt,
  faPercent,
  faPizzaSlice,
  faPlus,
  faQuestionCircle,
  faRocket,
  faSave,
  faSearch,
  faSearchPlus,
  faSignOutAlt,
  faSortDown,
  faSortUp,
  faStar,
  faStream,
  faThumbsUp,
  faTimes,
  faTrashAlt,
  faUniversity,
  faUser,
  faUserAltSlash,
  faUserEdit,
  faUserFriends,
  faUserPlus,
  faUserTie,
  faWindows,
  faConstruction,
  faExternalLinkAlt,
  faEnvelope,
  faChevronDown,
  faArchive,
  faSync,
  faBan,
  faPhone,
  faEnvelope,
  faRepeat,
  faSparkles,
  faCheckCircle,
  faMinusCircle,
  faEquals,
  faNotEqual,
  faGreaterThanEqual,
  faLessThanEqual,
  faUmbrella,
  faLock,
  faLockOpen,
  faHouseLock,
  faUndo,
  faBrain,
  faDownload,
  faPlusCircle
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('FontAwesomeLayers', FontAwesomeLayers)
